import styled from 'styled-components';

export const MetricsContainer = styled.div`
  background: rgba(15, 23, 42, 0.8);
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
  color: white;
`;

export const Title = styled.h3`
  margin: 0 0 1.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
`;

export const MetricsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const MetricItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
`;

export const MetricLabel = styled.span`
  font-size: 0.95rem;
`;

export const MetricValue = styled.span`
  background-color: #0F4C8A;
  color: white;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  min-width: 30px;
  text-align: center;
`;

export const ShowMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  background: none;
  border: none;
  color: white;
  padding: 1rem 0 0;
  margin-top: 1rem;
  cursor: pointer;
  font-size: 0.95rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;
